import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';

@Component({
  selector: 'app-form-send-email',
  templateUrl: './form-send-email.component.html',
  styleUrl: './form-send-email.component.scss'
})
export class FormSendEmailComponent {
  @Input() fieldTo: FormControl = null;
  @Input() fieldCc: FormControl = null;
  @Input() fieldCco: FormControl = null;
  @Input() message: FormControl = null;
  @Input() files: FormControl = null;
  @Output() onUploadFiles: EventEmitter<FileSelectEvent> = new EventEmitter<FileSelectEvent>();
  @Output() onClearFiles: EventEmitter<void> = new EventEmitter<void>();
  @Output() onRemoveFile: EventEmitter<FileRemoveEvent> = new EventEmitter<FileRemoveEvent>();
}